import { nameRegex } from '@/schema/utils';

export const isNameValid = (name: string) => {
  return nameRegex.test(name);
};
